var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: "720", title: "选择问答帖子" },
          on: { "on-ok": _vm.cursorSelect },
          model: {
            value: _vm.showSelectAuction,
            callback: function ($$v) {
              _vm.showSelectAuction = $$v
            },
            expression: "showSelectAuction",
          },
        },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("Input", {
                staticClass: "w200",
                attrs: { placeholder: "提问人名称" },
                on: { "on-enter": _vm.search },
                model: {
                  value: _vm.uname,
                  callback: function ($$v) {
                    _vm.uname = $$v
                  },
                  expression: "uname",
                },
              }),
              _vm._v(" "),
              _c(
                "Button",
                {
                  staticClass: "ml20",
                  attrs: { type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.search($event)
                    },
                  },
                },
                [_vm._v("筛选")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "h400 mt20",
              staticStyle: { "border-top": "1px solid #eee" },
            },
            [
              _c(
                "table",
                { staticClass: "spec-table" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("td", { attrs: { width: "40%", align: "center" } }, [
                        _vm._v("问答帖子信息"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "10%", align: "center" } }, [
                        _vm._v("分类"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "20%", align: "center" } }, [
                        _vm._v("状态"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("结果"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("操作"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.resultData, function (m, i) {
                    return _c("tbody", { key: i }, [
                      _c("tr", { staticClass: "border-t" }, [
                        _c("td", { staticClass: "bgWhite" }, [
                          _c(
                            "div",
                            { staticClass: "display-flex item-align-center" },
                            [
                              m.img
                                ? _c("img", {
                                    staticStyle: {
                                      width: "90px",
                                      height: "90px",
                                      display: "block",
                                      "flex-shrink": "0",
                                    },
                                    attrs: { src: m.img },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml10" }, [
                                _c("p", [_vm._v("编号：" + _vm._s(m.id))]),
                                _vm._v(" "),
                                _c("p", { staticClass: "mt5" }, [
                                  _vm._v(_vm._s(m.title)),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [_c("div", [_vm._v(_vm._s(m.category_name))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            m.refund_status === 1
                              ? _c(
                                  "div",
                                  { staticStyle: { color: "#DB1B1B" } },
                                  [_vm._v("已退款")]
                                )
                              : m.is_pay === 0
                              ? _c("div", { staticStyle: {} }, [
                                  _vm._v("未支付"),
                                ])
                              : m.is_answered === 1
                              ? _c(
                                  "div",
                                  { staticStyle: { color: "#0AAC28" } },
                                  [_vm._v("已回答")]
                                )
                              : !m.designated_expert &&
                                m.is_overdue === 0 &&
                                m.is_answered === 0
                              ? _c(
                                  "div",
                                  { staticStyle: { color: "#FFD015" } },
                                  [_vm._v("待分单")]
                                )
                              : m.is_overdue === 0 && m.is_answered === 0
                              ? _c(
                                  "div",
                                  { staticStyle: { color: "#FFD015" } },
                                  [_vm._v("待回答")]
                                )
                              : m.is_overdue === 1
                              ? _c(
                                  "div",
                                  { staticStyle: { color: "#B5B5B5" } },
                                  [_vm._v("已过期")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            m.collection_status == 1
                              ? _c("div", [_vm._v("真品")])
                              : m.collection_status == 2
                              ? _c("div", [_vm._v("赝品")])
                              : m.collection_status == 3
                              ? _c("div", [_vm._v("存疑")])
                              : _c("div", [_vm._v("无")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            _vm.selectedAuctionIdList.indexOf(m.id) == -1
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.auctionSelectedAction(
                                            $event,
                                            i
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("选择")]
                                  ),
                                ])
                              : _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          _vm.auctionCancelAction(
                                            $event,
                                            _vm.selectedAuctionIdList.indexOf(
                                              m.id
                                            )
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("取消选择")]
                                  ),
                                ]),
                          ]
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c("Page", {
                staticStyle: { "text-align": "right" },
                attrs: {
                  total: _vm.total,
                  "page-size": _vm.queryParams.size,
                  "show-sizer": "",
                  "show-total": "",
                  "show-elevator": "",
                  current: _vm.queryParams.page,
                },
                on: {
                  "on-page-size-change": _vm.changePageSize,
                  "on-change": _vm.changePage,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }